import React from "react";
import Checkbox from "@mui/material/Checkbox";
import { useDispatch } from "react-redux";
import classes from "./filters.module.css";

/**
 * A labeled multi-select checkbox group for the filter drawer.
 * Replaces the inline `FilterMenu`, but reads its current selection from
 * Redux (`selected`) instead of local state, so the drawer reflects active
 * filters and a single "Clear All" works.
 *
 * Props:
 *  - label: section title
 *  - options: string[] of selectable values
 *  - selected: string[] currently-selected values (from state.filter.<key>)
 *  - action: redux action creator; dispatched with the next selected array
 */
const CheckboxFilterGroup = ({ label, options = [], selected = [], action }) => {
  const dispatch = useDispatch();
  const current = selected || [];

  const toggle = (value) => {
    const next = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];
    dispatch(action(next));
  };

  if (!options || options.length === 0) {
    return null;
  }

  return (
    <div className={classes.section}>
      <span className={classes.sectionLabel}>{label}</span>
      <div className={classes.optionList}>
        {options.map((item, index) => (
          <label key={index} className={classes.optionRow}>
            <Checkbox
              size="small"
              checked={current.includes(item)}
              onChange={() => toggle(item)}
            />
            {String(item).replaceAll("_", " ")}
          </label>
        ))}
      </div>
    </div>
  );
};

export default CheckboxFilterGroup;
